module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box-header-classes-me"
  }, [_c('a', {
    staticClass: "tab-link",
    class: _vm.isActive == 1 ? 'active' : '',
    on: {
      "click": function($event) {
        return _vm.routeHref('classes_to_me_chat')
      }
    }
  }, [_vm._v("Chat")]), (_vm.isPublic) ? _c('a', {
    staticClass: "tab-link",
    class: _vm.isActive == 2 ? 'active' : '',
    on: {
      "click": function($event) {
        return _vm.routeHref('classes_to_me_exercise')
      }
    }
  }, [_vm._v("Bài tập")]) : _vm._e(), (_vm.isPublic) ? _c('a', {
    staticClass: "tab-link",
    class: _vm.isActive == 3 ? 'active' : '',
    on: {
      "click": function($event) {
        return _vm.routeHref('classes_to_me_video')
      }
    }
  }, [_vm._v("Video")]) : _vm._e(), (_vm.isPublic) ? _c('a', {
    staticClass: "tab-link",
    class: _vm.isActive == 4 ? 'active' : '',
    on: {
      "click": function($event) {
        return _vm.routeHref('classes_to_me_lesson')
      }
    }
  }, [_vm._v("Lý thuyết")]) : _vm._e()]), _c('div', {
    staticClass: "box-body-classes-me"
  }, [(_vm.isActive == 1) ? _c('div', [_c('FrontChat')], 1) : (_vm.isActive == 2 && _vm.isPublic) ? _c('div', [_c('FrontExercise', {
    attrs: {
      "pcID": _vm.pcID,
      "classID": _vm.classID,
      "pcInfo": _vm.pcInfo
    }
  })], 1) : (_vm.isActive == 3 && _vm.isPublic) ? _c('div', {
    attrs: {
      "pcInfo": _vm.pcInfo
    }
  }, [_c('FrontVideo', {
    attrs: {
      "pcID": _vm.pcID,
      "classID": _vm.classID,
      "pcInfo": _vm.pcInfo
    }
  })], 1) : (_vm.isActive == 4 && _vm.isPublic) ? _c('div', [_c('FrontLesson', {
    attrs: {
      "pcID": _vm.pcID,
      "classID": _vm.classID,
      "pcInfo": _vm.pcInfo
    }
  })], 1) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fd7b5d20","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ClassesMe/detail.vue
// module id = 1670
// module chunks = 0